export function isPersistenceType(value) {
    return ['cookie', 'localStorage'].includes(value);
}
//# sourceMappingURL=config.js.map